import React, { useEffect } from 'react'
import {
  FaRegLightbulb,
  FaMoneyBillWave,
  FaChartLine,
  FaShoppingCart,
  FaUsers,
} from 'react-icons/fa'

import Breadcrum from '../../components/breadcrum'
import DashboardCard from '../../components/dashboardCard'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getInsightCount } from '../../api/dashboardApi'
import toast from 'react-hot-toast'
import { Bar, Line } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
)

const Dashboard = () => {
  useEffect(() => {
    document.title = 'Dealdashboard'
  }, [])

  const { data, isLoading, isError } = useQuery({
    queryKey: ['insightCount'],
    queryFn: getInsightCount,
    onError: (error) => {
      toast.error(error)
    },
  })

  if (isLoading) {
    return (
      <>
        <Breadcrum subheading="Dashboard" link="/dealdashboard" />
        <div className="text-center py-8">Loading Dashboard...</div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum subheading="Dashboard" link="/dealdashboard" />
        <div className="text-center py-8 text-red-500">
          Error loading Dashboard. Please try again later.
        </div>
      </>
    )
  }

  const chartLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May']

  const barData = {
    labels: chartLabels,
    datasets: [
      {
        label: 'Latest',
        data: [30, 50, 45, 60, 70],
        backgroundColor: '#ff7010',
      },
      {
        label: 'Funding',
        data: [20, 40, 35, 50, 55],
        backgroundColor: '#339306',
      },
      {
        label: 'Financial',
        data: [15, 30, 25, 35, 40],
        backgroundColor: '#A91E1E',
      },
    ],
  }

  const lineData = {
    labels: chartLabels,
    datasets: [
      {
        label: 'Financial Insights',
        data: [10, 25, 35, 40, 60],
        fill: false,
        borderColor: '#ff7010',
        tension: 0.4,
      },
    ],
  }

  const latestData = {
    labels: chartLabels,
    datasets: [
      {
        label: 'Latest Deals',
        data: [10, 20, 30, 25, 35],
        fill: false,
        borderColor: '#ff7010',
        tension: 0.4,
      },
    ],
  }

  const fundingData = {
    labels: chartLabels,
    datasets: [
      {
        label: 'Funding Trend',
        data: [15, 25, 35, 45, 40],
        fill: false,
        borderColor: '#339306',
        tension: 0.4,
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  }

  return (
    <>
      <Breadcrum subheading="Dashboard" link="/dealdashboard" />
      <div className="mt-10 flex flex-wrap gap-2 sm:justify-between justify-center">
        <Link to="latestDeal">
          <DashboardCard
            title="Latest Deal"
            icon={FaRegLightbulb}
            count={data.latestCount}
          />
        </Link>
        <Link to="funding">
          <DashboardCard
            title="Funding 365"
            icon={FaMoneyBillWave}
            count={data.fundingCount}
          />
        </Link>
        <Link to="financial">
          <DashboardCard
            title="Financial Insight"
            icon={FaChartLine}
            count={data.financialCount}
          />
        </Link>
        <DashboardCard title="Total Orders" icon={FaShoppingCart} count="58" />
        <DashboardCard title="Total Users" icon={FaUsers} count="58" />
      </div>

      <div className="mt-10">
        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">
            Latest vs Funding vs Financial
          </h2>
          <Bar data={barData} options={chartOptions} />
        </div>
      </div>
      <div className="mt-10 grid gap-10 grid-cols-1 lg:grid-cols-3">
        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">
            Financial Insights Trend
          </h2>
          <Line data={lineData} options={chartOptions} />
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">Latest Deals Trend</h2>
          <Line data={latestData} options={chartOptions} />
        </div>
        <div className="bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">Funding Trend</h2>
          <Line data={fundingData} options={chartOptions} />
        </div>
      </div>
    </>
  )
}

export default Dashboard
